/**
 * Brand Assets Configuration
 * 
 * Centralized logo and brand asset URLs.
 * Chain29.com branding.
 */

// Cache busting version (update this to force browser refresh)
const LOGO_VERSION = "v3-gold-metallic";

// Chain29 Logo (local) with cache busting
export const CHAIN29_LOGO = `/chain29-logo.png?${LOGO_VERSION}`;

// Main logo aliases
export const ASTERPOS_LOGO = CHAIN29_LOGO;
export const BACKOFFICE_LOGO = CHAIN29_LOGO;
export const COMPANY_LOGO = CHAIN29_LOGO;

// Default team member avatar placeholder
export const DEFAULT_AVATAR = CHAIN29_LOGO;

// Favicon
export const FAVICON = CHAIN29_LOGO;

export default {
  CHAIN29_LOGO,
  ASTERPOS_LOGO,
  BACKOFFICE_LOGO,
  COMPANY_LOGO,
  DEFAULT_AVATAR,
  FAVICON,
};
